import 'regenerator-runtime/runtime';
import { call, takeEvery, takeLatest } from 'redux-saga/effects';
import { AdressVerzeichnisRequestModel, AdressVerzeichnisResponse, Status } from '@ps20/bff-models';
import {
  AddressvalidierungAction,
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';

export const URL_ADRESSVALIDIERUNG = '/privatschutz/api/validiereadresse';

export function* adressvalidierungSaga() {
  yield takeLatest(GlobalActions.ADRESSE_VALIDIEREN, safeSaga(validiereAdresse, App.SHOP));
  yield takeEvery(
    GlobalActions.ADRESSE_VALIDIEREN_REQUEST_SUCCESSFULL,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(
    GlobalActions.ADRESSE_VALIDIEREN_REQUEST_FAILED,
    safeSaga(errorCallback, App.SHOP),
  );
}

export function* validiereAdresse(action: GlobalAction<AddressvalidierungAction>) {
  const payload = action.payload;

  const adressvaliderungsRequest: AdressVerzeichnisRequestModel = {
    plz: payload.plz,
    ortschaft: payload.ortschaft,
    strasse: payload.strasse,
    hausnummer: payload.hausnummer,
    nurOrteRequired: false,
  };

  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      body: adressvaliderungsRequest,
      url: URL_ADRESSVALIDIERUNG,
      successEvent: GlobalActions.ADRESSE_VALIDIEREN_REQUEST_SUCCESSFULL,
      errorEvent: GlobalActions.ADRESSE_VALIDIEREN_REQUEST_FAILED,
      originEvent: action,
      noCache: true,
    }),
  );
}

export function* successCallback(
  successAction: DoRequestResponse<AdressVerzeichnisResponse, AdressVerzeichnisRequestModel>,
) {
  const globalPut = GlobalPut.getInstance();
  if (Status.OK === successAction.payload.status) {
    yield call([globalPut, globalPut.put], new GlobalActions().adresseValidierenSuccess());
  } else {
    yield call([globalPut, globalPut.put], new GlobalActions().adresseValidierenFailed());
  }
}

export function* errorCallback() {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().adresseValidierenFailed());
}
